import { render, staticRenderFns } from "./SingleSociety.vue?vue&type=template&id=3752b0d2&scoped=true&"
import script from "./SingleSociety.vue?vue&type=script&lang=js&"
export * from "./SingleSociety.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3752b0d2",
  null
  
)

export default component.exports